export default function renderLinkChildren({ children, isHovering = false }) {
  if (typeof children === 'function') {
    return children({ isHovering });
  }

  return children;
}
